module.exports = __webpack_public_path__ + "pin_black.2dc410.png";